export default "__VITE_ASSET__BHZbsbhT__"